<script setup lang="ts">
const { t } = useI18n({ useScope: "local" });
const props = defineProps<{ id: string }>();

const { field } = useInlineBlockEditor(props.id);

const text = field<string>("text", "Default Title");
</script>

<template>
  <EditorSection :title="t('title')" icon="lucide:letter-text" accent="container">
    <EditorField :label="t('textLabel')">
      <Input v-model="text" class="h-8 rounded-sm bg-muted text-[13px]" :placeholder="t('textPlaceholder')" />
    </EditorField>
  </EditorSection>
</template>

<i18n lang="yaml">
en:
  title: "Card Header Title"
  textLabel: "Title Text"
  textPlaceholder: "Enter title text"
</i18n>
